import { useCallback } from "react";

import { useMutation } from "@apollo/client";
import { toast } from "react-toastify";

import Button from "components/common/Button";

import useCourtInformation from "hooks/me/useCourtInformation";

import assignObjectValuesToSet from "utils/assignObjectValuesToSet";
import getVariablesForAllLawyersQuery from "utils/lawyers/getVariablesForAllLawyersQuery";

import ALL_LAWYERS from "@gql/sanity/allLawyers";
import UPDATE_LAWYER from "@gql/sanity/mutations/updateLawyer";

const UpdateLawyerInDatabaseButton = ({ user, values, lawyerObject }) => {
  const [updateLawyer, { loading }] = useMutation(UPDATE_LAWYER);

  const { provinceShorthand } = useCourtInformation(user.client);

  const handleSubmitChanges = useCallback(async () => {
    const { location, name, orgName, sanityId } = values;

    const variables = {
      updateSanity: true,
      where: { id: lawyerObject.id },
      data: {
        ...assignObjectValuesToSet({ name, orgName, sanityId }),
        location: { create: location, update: assignObjectValuesToSet(location) },
      },
    };

    try {
      await updateLawyer({
        variables,
        refetchQueries: [
          {
            query: ALL_LAWYERS,
            variables: getVariablesForAllLawyersQuery({ residence: provinceShorthand }),
          },
        ],
        awaitRefetchQueries: true,
      });
    } catch (error) {
      if (error.graphQLErrors) error.graphQLErrors.forEach(({ message }) => toast.error(message));
    }
  }, [updateLawyer, values, provinceShorthand, lawyerObject?.id]);

  return (
    <div className="info-tip update-lawyer-card mb-3">
      <p>
        You've changed the lawyer profile information. Submit these changes to the Divorcepath
        lawyer database?
      </p>
      <div className="actions" style={{ display: "flex", gap: "0.5rem" }}>
        <Button disabled={loading} onClick={handleSubmitChanges}>
          Update Database
        </Button>
      </div>
    </div>
  );
};

export default UpdateLawyerInDatabaseButton;
